import { CARD_VARIANT, HEADER_VARIANT } from '../constants';

/**
 * @param {'vertical' | 'horizontal'} cardVariant
 * @param {boolean} hasCover
 */
export const getHeaderVariant = (cardVariant, hasCover) =>
  hasCover
    ? cardVariant === CARD_VARIANT.VERTICAL
      ? HEADER_VARIANT.FLOAT
      : Array.isArray(cardVariant)
      ? cardVariant.map(v => (v === CARD_VARIANT.VERTICAL ? HEADER_VARIANT.FLOAT : HEADER_VARIANT.STATIC))
      : HEADER_VARIANT.STATIC
    : HEADER_VARIANT.STATIC;

const cardVariantToFixedStyleMap = {
  [CARD_VARIANT.VERTICAL]: 'height',
  [CARD_VARIANT.HORIZONTAL]: 'width',
};

/**
 * @param {'vertical' | 'horizontal'} cardVariant
 * @param {string} fixedCoverSize
 */
export const computeFixedCoverStyle = (cardVariant, fixedCoverSize) =>
  fixedCoverSize
    ? Array.isArray(cardVariant)
      ? {
          width: cardVariant.map(v => (cardVariantToFixedStyleMap[v] === 'width' ? fixedCoverSize : '100%')),
          height: cardVariant.map(v =>
            cardVariantToFixedStyleMap[v] === 'height' ? fixedCoverSize : 'auto'
          ),
        }
      : {
          [cardVariantToFixedStyleMap[cardVariant]]: fixedCoverSize,
        }
    : {};
